import React from 'react';

const HEADER_STYLES = {
  company: {
    labelColor: 'rgba(255,255,255,0.6)',
    lineLeft: 'linear-gradient(to right, transparent, rgba(255,255,255,0.5), rgba(255,255,255,0.3))',
    lineRight: 'linear-gradient(to left, transparent, rgba(255,255,255,0.5), rgba(255,255,255,0.3))',
    collapsedLine: 'linear-gradient(to right, transparent, rgba(255,255,255,0.3), transparent)',
  },
  project: {
    labelColor: 'rgba(100,200,255,0.8)',
    lineLeft: 'linear-gradient(to right, transparent, rgba(100,200,255,0.6), rgba(100,200,255,0.4))',
    lineRight: 'linear-gradient(to left, transparent, rgba(100,200,255,0.6), rgba(100,200,255,0.4))',
    collapsedLine: 'linear-gradient(to right, transparent, rgba(100,200,255,0.4), transparent)',
  },
  settings: {
    labelColor: 'rgba(255,255,255,0.6)',
    lineLeft: 'linear-gradient(to right, transparent, rgba(255,255,255,0.5), rgba(255,255,255,0.3))',
    lineRight: 'linear-gradient(to left, transparent, rgba(255,255,255,0.5), rgba(255,255,255,0.3))',
    collapsedLine: 'linear-gradient(to right, transparent, rgba(255,255,255,0.3), transparent)',
  },
  // Accent, not the company grey or the project blue: inside a tender the whole
  // sidebar is replaced, and a mode you cannot see you are in is a trap.
  tender: {
    labelColor: 'rgba(248,162,51,0.85)',
    lineLeft: 'linear-gradient(to right, transparent, rgba(248,162,51,0.6), rgba(248,162,51,0.4))',
    lineRight: 'linear-gradient(to left, transparent, rgba(248,162,51,0.6), rgba(248,162,51,0.4))',
    collapsedLine: 'linear-gradient(to right, transparent, rgba(248,162,51,0.4), transparent)',
  },
};

export function NavSectionHeader({ collapsed, label, variant = 'company', className = 'mt-1' }) {
  const s = HEADER_STYLES[variant] || HEADER_STYLES.company;
  if (collapsed) {
    return (
      <div className="py-1">
        <div style={{ height: '1px', margin: '0 10px', background: s.collapsedLine }} />
      </div>
    );
  }
  return (
    <div className={`px-3 py-2 ${className}`.trim()}>
      <div className="d-flex align-items-center">
        <div style={{ flex: 1, height: '1px', background: s.lineLeft }} />
        <span
          className="px-2 text-uppercase"
          style={{ fontSize: '0.65rem', color: s.labelColor, letterSpacing: '1px', fontWeight: '600' }}
        >
          {label}
        </span>
        <div style={{ flex: 1, height: '1px', background: s.lineRight }} />
      </div>
    </div>
  );
}

export function NavSubmenuLabel({ children, className = '' }) {
  return (
    <div className={`sidebar-submenu-label text-uppercase px-4 py-1 ${className}`.trim()}>
      {children}
    </div>
  );
}

export function NavSubmenuDivider() {
  return <div className="border-top border-secondary my-1 mx-4" />;
}
